import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/nfse')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_fiscal_nfse }) => isPermissionParcialOrFull(upp_fiscal_nfse),
        }),
});
